export default __webpack_public_path__ + "static/media/32_Gs.061e12b1.svg";